import type { MetaDescriptor } from 'react-router'
import { useParams } from 'react-router'
import KnowledgeArticleTemplate from '../../templates/KnowledgeArticleTemplate'
import NotFoundPage from '../../pages/NotFound/NotFoundPage'
import { getArticleBySlug } from '../../content/knowledge/index'
import { getEntryByIdString } from '../../content/registry'
import { buildPageMeta } from '../../seo/meta'

export const handle = { locale: 'nl' }

export function meta({ params }: { params: Record<string, string | undefined> }): MetaDescriptor[] {
  const article = getArticleBySlug(params.articleId ?? '', 'nl')
  if (!article) return [{ title: '404' }, { name: 'robots', content: 'noindex, follow' }]
  const entry = getEntryByIdString(article.id)
  return entry ? buildPageMeta({ entry, locale: 'nl' }) : []
}

export default function Route() {
  const { articleId } = useParams()
  const article = getArticleBySlug(articleId ?? '', 'nl')
  if (!article) return <NotFoundPage locale='nl' />
  return <KnowledgeArticleTemplate article={article} locale='nl' />
}
